import { render, staticRenderFns } from "./CoozzyEnvelopeIcon.vue?vue&type=template&id=072b2ca6&scoped=true"
import script from "./CoozzyEnvelopeIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyEnvelopeIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyEnvelopeIcon.vue?vue&type=style&index=0&id=072b2ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b2ca6",
  null
  
)

export default component.exports